import React from 'react';

const ContactIcon = () => {
      return (
            <>
                  <span className="material-symbols-outlined">contacts</span>
            </>
      );
};

export default ContactIcon;
